import React from 'react'
import PreviousCarts from '../Components/PreviousCarts'

function PreviousOrders() {
  return (
    <div>
        <PreviousCarts/>
    </div>
  )
}

export default PreviousOrders